import script from "./ProjectInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInfo.vue?vue&type=style&index=0&id=d6fe4f44&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6fe4f44"]])

export default __exports__